import { Directive, Output } from '@angular/core';
import { SizeService } from './size.service';

/**
 * Measure and make available the element's size.
 * Be careful not to create loops.
 */
@Directive({
  selector: '[clientSize]',
  providers: [SizeService],
})
export class SizeDirective {
  @Output()
  readonly clientSize = this.sizeService.size;

  constructor(private readonly sizeService: SizeService) {}
}
